import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1be1756e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "creation-overlay"
}
const _hoisted_2 = { class: "creation-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "creation-spinner" }, null, -1))
const _hoisted_4 = { class: "creation-title" }
const _hoisted_5 = { class: "creation-subtitle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "creation-check" }, "✓", -1))
const _hoisted_7 = { class: "creation-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "creation-subtitle" }, "Opening your flow editor...", -1))
const _hoisted_9 = { class: "wizard-header" }
const _hoisted_10 = { class: "wizard-header-main" }
const _hoisted_11 = { class: "wizard-header-top" }
const _hoisted_12 = { class: "wizard-header-title" }
const _hoisted_13 = { class: "assistant-beta-badge" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wizard-mode-switch__thumb" }, null, -1))
const _hoisted_15 = { class: "wizard-header-actions" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = ["aria-label"]
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = { class: "wizard-body" }
const _hoisted_21 = { class: "wizard-content-panel" }
const _hoisted_22 = {
  key: 0,
  class: "wizard-history-flyout"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_WizardChat = _resolveComponent("WizardChat")!
  const _component_WizardHistory = _resolveComponent("WizardHistory")!
  const _component_ConnectionSetupDialog = _resolveComponent("ConnectionSetupDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "creation-fade" }, {
        default: _withCtx(() => [
          (_ctx.overlayPhase)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.overlayPhase === 'creating')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_3,
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.overlayAction === "updated"
                  ? "Updating your flow..."
                  : "Creating your flow..."), 1),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.overlayAction === "updated"
                  ? "Hang tight, we're applying the latest version for you"
                  : "Hang tight, we're building it for you"), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_6,
                        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.overlayAction === "updated" ? "Flow updated!" : "Flow created!"), 1),
                        _hoisted_8
                      ], 64))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    _createVNode(_Transition, {
      name: _ctx.inline ? '' : 'wizard-slide'
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(_ctx.inline ? 'wizard-inline' : 'wizard-overlay'),
          onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBackdropClick && _ctx.handleBackdropClick(...args)), ["self"]))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.inline ? 'wizard-inline-container' : 'wizard-shell')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["wizard-drawer", { 'wizard-drawer--history-open': _ctx.historyVisible }])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: _ctx.mode === 'chat' ? 'comment' : 'magic',
                        class: "wizard-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_Transition, {
                        name: "wizard-title-fade",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("span", { key: _ctx.displayTitle }, _toDisplayString(_ctx.displayTitle), 1))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.betaLabel), 1)
                    ]),
                    (_ctx.showModeSwitch)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["wizard-mode-switch", `wizard-mode-switch--${_ctx.switchVisualMode}`]),
                          role: "tablist",
                          "aria-label": "Wizard mode selector",
                          onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearModeHover && _ctx.clearModeHover(...args)))
                        }, [
                          _hoisted_14,
                          _createElementVNode("button", {
                            class: _normalizeClass(["wizard-mode-switch__option", { 'is-active': _ctx.switchVisualMode === 'wizard' }]),
                            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previewMode('wizard'))),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchMode('wizard')))
                          }, " Creator ", 34),
                          _createElementVNode("button", {
                            class: _normalizeClass(["wizard-mode-switch__option", { 'is-active': _ctx.switchVisualMode === 'chat' }]),
                            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previewMode('chat'))),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchMode('chat')))
                          }, " Chat ", 34)
                        ], 34))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      (_ctx.openInEditorEnabled)
                        ? (_openBlock(), _createBlock(_component_ElTooltip, {
                            key: 0,
                            effect: "custom",
                            placement: "bottom",
                            "show-after": 250,
                            content: _ctx.t('TeggyAssistant.OpenInEditor')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "btn btn-link wizard-header-btn",
                                type: "button",
                                "aria-label": _ctx.t('TeggyAssistant.OpenInEditor'),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('open-in-editor')))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "edit" })
                              ], 8, _hoisted_16)
                            ]),
                            _: 1
                          }, 8, ["content"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ElTooltip, {
                        effect: "custom",
                        placement: "bottom",
                        "show-after": 250,
                        content: _ctx.t('TeggyAssistant.ChatHistory')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btn btn-link wizard-header-btn", { 'wizard-header-btn--active': _ctx.historyVisible }]),
                            type: "button",
                            "aria-label": _ctx.t('TeggyAssistant.ChatHistory'),
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleHistory && _ctx.toggleHistory(...args)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "history" })
                          ], 10, _hoisted_17)
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      (_ctx.sessionId || _ctx.messages.length > 0)
                        ? (_openBlock(), _createBlock(_component_ElTooltip, {
                            key: 1,
                            effect: "custom",
                            placement: "bottom",
                            "show-after": 250,
                            content: _ctx.t('TeggyAssistant.NewChat')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "btn btn-link wizard-header-btn",
                                type: "button",
                                "aria-label": _ctx.t('TeggyAssistant.NewChat'),
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleNewChat && _ctx.handleNewChat(...args)))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "plus" })
                              ], 8, _hoisted_18)
                            ]),
                            _: 1
                          }, 8, ["content"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ElTooltip, {
                        effect: "custom",
                        placement: "bottom",
                        "show-after": 250,
                        content: _ctx.t('Common.Close')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-link wizard-header-btn wizard-header-btn--close",
                            type: "button",
                            "aria-label": _ctx.t('Common.Close'),
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ], 8, _hoisted_19)
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_WizardChat, {
                    "can-stop": _ctx.canStop,
                    "interruption-notice": _ctx.interruptionNotice,
                    messages: _ctx.messages,
                    loading: _ctx.loading,
                    mode: _ctx.mode,
                    "status-message": _ctx.statusMessage,
                    "status-detail-message": _ctx.statusDetailMessage,
                    "session-id": _ctx.sessionId,
                    "ensure-upload-session-id": _ctx.ensureUploadSessionId,
                    "context-level": _ctx.contextLevel,
                    "context-menu-open": _ctx.contextMenuOpen,
                    compacting: _ctx.compacting,
                    "context-error": _ctx.contextError,
                    "connection-prompt": _ctx.connectionPrompt,
                    onSend: _ctx.handleSend,
                    onStop: _ctx.handleStop,
                    onToggleContext: _ctx.toggleContextMenu,
                    onCloseContext: _cache[9] || (_cache[9] = ($event: any) => (_ctx.contextMenuOpen = false)),
                    onCompactContext: _ctx.handleCompactContext,
                    onOpenConnectionSetup: _ctx.openConnectionSetup,
                    onDismissConnectionSetup: _ctx.dismissConnectionSetup
                  }, null, 8, ["can-stop", "interruption-notice", "messages", "loading", "mode", "status-message", "status-detail-message", "session-id", "ensure-upload-session-id", "context-level", "context-menu-open", "compacting", "context-error", "connection-prompt", "onSend", "onStop", "onToggleContext", "onCompactContext", "onOpenConnectionSetup", "onDismissConnectionSetup"])
                ])
              ])
            ], 2),
            _createVNode(_Transition, { name: "wizard-history-slide" }, {
              default: _withCtx(() => [
                (_ctx.historyVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_WizardHistory, {
                        sessions: _ctx.historySessions,
                        loading: _ctx.historyLoading,
                        "active-session-id": _ctx.sessionId,
                        onNewChat: _ctx.handleNewChat,
                        onSelectSession: _ctx.handleSelectSession
                      }, null, 8, ["sessions", "loading", "active-session-id", "onNewChat", "onSelectSession"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ConnectionSetupDialog, {
              modelValue: _ctx.showConnectionSetup,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showConnectionSetup) = $event)),
              request: _ctx.connectionSetupRequest,
              onCreated: _ctx.onConnectionCreated
            }, null, 8, ["modelValue", "request", "onCreated"])
          ], 2)
        ], 2), [
          [_vShow, _ctx.visible]
        ])
      ]),
      _: 1
    }, 8, ["name"])
  ], 64))
}